import { AuthType, EmbedConfig } from '@thoughtspot/visual-embed-sdk'

export const createThoughtSpotConfig = (
  token: string | undefined
): EmbedConfig => ({
  thoughtSpotHost: 'https://jacquard.thoughtspot.cloud',
  authType: AuthType.TrustedAuthTokenCookieless,
  ...(token && {
    getAuthToken: () => Promise.resolve(token),
    disableTokenVerification: true,
  }),
  callPrefetch: true,
  customizations: {
    content: {
      strings: {
        Spotter: 'Jaqi',
      },
    },
    style: {
      customCSS: {
        variables: {
          '--ts-var-spotter-prompt-background': '#fbf7f0',
          '--ts-var-root-background': '#FFFDF9',
          '--ts-var-root-color': '#15020C',
          '--ts-var-button-border-radius': '100px',
          '--ts-var-button--icon-border-radius': '2px',
          '--ts-var-button--primary-background': '#FFE661',
          '--ts-var-button--primary--hover-background': '#FFF3B0',
          '--ts-var-button--primary--active-background': '#FFE661',
          '--ts-var-button--primary-color': '#15020C',
          '--ts-var-root-text-transform': 'none',
          '--ts-var-button--secondary--active-background': '#E7D4AF',
          '--ts-var-button--secondary-background': 'transparent',
          '--ts-var-button--secondary--hover-background': '#FFF3B0',
          '--ts-var-button--secondary-color': '#605030',
          '--ts-var-viz-background': '#FFFDF9',
          '--ts-var-axis-data-label-color': '#15020C',
          '--ts-var-axis-title-color': '#15020C',
          '--ts-var-viz-description-color': '#605030',
          '--ts-var-viz-border-radius': '2px',
          '--ts-var-button--tertiary-background': '#E7D4AF',
          '--ts-var-button--tertiary--active-background': '#E7D4AF',
          '--ts-var-viz-legend-hover-background': '#FFF3B0',
          '--ts-var-viz-title-color': '#15020C',
          '--ts-var-viz-box-shadow': '0px 0px 0px 0px none',
          '--ts-var-viz-title-text-transform': 'none',
          '--ts-var-viz-description-text-transform': 'none',
          '--ts-var-button--tertiary--hover-background': '#FFF3B0',
          '--ts-var-button--tertiary-color': '#605030',
          '--ts-var-chip-background': '#FBF7F0',
          '--ts-var-chip-border-radius': '2px',
          '--ts-var-nav-background': '#7A004B',
          '--ts-var-nav-color': '#15020C',
          '--ts-var-menu-color': '#605030',
          '--ts-var-menu-background': '#FBF7F0',
          '--ts-var-menu--hover-background': '#FFF3B0',
          '--ts-var-chip-color': '#605030',
          '--ts-var-chip--hover-background': '#FFF3B0',
          '--ts-var-chip--hover-color': '#15020C',
          '--ts-var-chip--active-background': '#E0C797',
          '--ts-var-chip--active-color': '#15020C',
          '--ts-var-chip-box-shadow': '0px 0px 0px 0px none',
          '--ts-var-dialog-body-background': '#FBF7F0',
          '--ts-var-dialog-body-color': '#15020C',
          '--ts-var-dialog-footer-background': '#FBF7F0',
          '--ts-var-dialog-header-background': '#FBF7F0',
          '--ts-var-dialog-header-color': '#15020C',
          '--ts-var-search-bar-text-font-color': '#15020C',
          '--ts-var-search-bar-text-font-style': 'none',
          '--ts-var-search-auto-complete-font-color': '#15020C',
          '--ts-var-search-auto-complete-subtext-font-color': '#605030',
          '--ts-var-search-bar-auto-complete-hover-background': '#FFFDF9',
          '--ts-var-search-auto-complete-background': '#FFFDF9',
          '--ts-var-search-bar-background': '#FFFDF9',
          '--ts-var-menu-text-transform': 'none',
          '--ts-var-answer-edit-panel-background-color': '#FBF7F0',
          '--ts-var-checkbox-active-color': '#15020C',
          '--ts-var-checkbox-background-color': 'transparent',
          '--ts-var-checkbox-border-color': '#E0C797',
          '--ts-var-checkbox-checked-color': '#15020C',
          '--ts-var-checkbox-checked-disabled': '#EEDFC2',
          '--ts-var-checkbox-error-border': '#DC2A50',
          '--ts-var-checkbox-hover-border': '#A89163',
          '--ts-var-axis-data-label-font-family':
            'Outfit,ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont',
          '--ts-var-root-font-family':
            'Outfit,ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont',
          '--ts-var-liveboard-tile-table-header-background': '#FBF7F0',
          '--ts-var-liveboard-tile-background': '#F6EFE0',
          '--ag-border-color': '#EFE2C8',
          '--ag-row-border-color': '#EFE2C8',
          '--ag-column-border-color': '#EFE2C8',
          '--ag-secondary-border-color': '#EFE2C8',
          '--ag-header-background-color': '#faf6ee',
          '--ag-background-color': '#FFFDF9',
          '--ag-odd-row-background-color': '#FFFDF9',
          '--ts-var-liveboard-tile-border-color': 'none',
          '--ts-var-liveboard-tile-border-radius': '2px',
          '--ts-var-list-hover-background': '#FFFCEB',
          '--ts-var-answer-chart-hover-background': '#FFFCEB',
          '--ts-var-answer-chart-select-background': '#FBF7F0',
          '--ts-var-segment-control-hover-background': '#FFFCEB',
          '--ts-var-list-selected-background': '#FFF3B0',
          '--ts-var-answer-view-table-chart-switcher-background': '#FBF7F0',
          '--ts-var-answer-data-panel-background-color': '#FBF7F0',
          '--ts-var-answer-view-table-chart-switcher-active-background':
            '#EFE2C8',
          '--ts-var-search-data-button-font-color': '#15020C',
          '--ts-var-search-data-button-background': 'transparent',
          '--ts-var-spotter-input-background': '#FFFDF9',
          '--ts-var-root-secondary-color': '#605030',
          '--ts-var-search-navigation-button-background': '#FFFDF9',
          '--ts-var-search-bar-navigation-help-text-background': '#FFFDF9',
          '--ts-var-application-color': '#605030',
          '--cord-thread-border-radius': '2px',
          '--cord-annotation-pin-drop-shadow': '0 0 0 0 none',
          '--cord-border-radius-medium': '2px',
          '--box-shadow': 'none',
          '--ts-var-home-favorite-suggestion-card-background': '#EFE2C8',
          '--ts-var-home-favorite-suggestion-card-icon-color': '#605030',
          '--ts-var-home-favorite-suggestion-card-text-color': '#605030',
          '--ts-var-home-watchlist-selected-text-color': '#15020C',
          '--ts-var-menu-selected-text-color': '#15020C',
          '--ts-var-liveboard-layout-background': '#FFFDF9',
          '--ts-var-menu-seperator-background': '#EFE2C8',
        } as any,
        rules_UNSTABLE: {
          '.icon-module__iconStyle.icon-module__xxl, .icon-module__iconStyle.icon-module__xs, .icon-module__iconStyle.icon-module__m':
            {
              display: 'none',
            },
          '.pinboard-module__pinboardPage': {
            'padding-right': '60px',
          },
          '.pinboard-header-module__editButton .button-module__button': {
            'text-decoration': 'underline',
          },
          '.kpi-module__sublabel': {
            color: '#605030',
          },
          '.kpi-module__timeBucket': {
            color: '#15020C',
          },
          '.kpi-module__backgroundColorComparison:hover': {
            'background-color': '#FFFCEB',
          },
          '.highcharts-axis-line': {
            stroke: '#E0C797',
          },
          '.highcharts-yaxis-line': {
            stroke: '#E0C797',
          },
          '.button-module__backgroundColored.button-module__primary': {
            'background-color': 'transparent',
          },
          '.button-module__backgroundColored.button-module__primary:not(.button-module__disabled):hover':
            {
              'background-color': '#FFF3B0',
            },
          '.ag-theme-alpine .ag-header-viewport': {
            'border-bottom': '0px',
          },
          '.ag-theme-alpine .ag-ltr .ag-cell': {
            'border-right': 'solid #EFE2C8',
          },
          '.bk-outline .ag-theme-alpine .ag-row': {
            'background-color': '#FFFDF9',
          },
          '.bk-zebra .ag-theme-alpine .ag-row:hover, .bk-outline .ag-theme-alpine .ag-row:hover':
            {
              'background-color': '#FFFCEB',
            },
          '.table-viz-footer-module__footer': {
            color: '#15020C',
          },
          '.avatars-module__timestamp': {
            color: '#605030',
          },
          '.chat-input-module__previewButton .button-module__backgroundLight.button-module__tertiary, .chat-input-module__resetChatButton .button-module__backgroundLight.button-module__tertiary':
            {
              'background-color': 'transparent !important',
            },
          '.answer-module__searchCurtain': {
            'background-color': 'transparent',
          },
          '.data-sources-v2-module__searchInputBox [data-radiant-v2] .input-base-module__container':
            {
              'background-color': '#fff',
              border: '1px solid #E0C797',
              'border-radius': '2px',
              'min-height': '40px',
            },
          '.data-sources-v2-module__searchInputBox [data-radiant-v2] .input-base-module__container:hover':
            {
              border: '1px solid #A89163',
            },
          '.data-sources-v2-module__searchInputBox[data-radiant-v2] .input-base-module__container.input-base-module__hasFocus':
            {
              border: '1px solid #15020C',
            },
          '.data-sources-v2-module__searchInputBox [data-radiant-v2] .input-base-module__input::placeholder':
            {
              color: '#A89163',
            },
          '.data-sources-v2-module__searchInputBox [data-radiant-v2].icon-module__gray':
            {
              fill: '#605030',
            },
          '.accordion-module__accordionItemHeaderWrapper:hover': {
            'background-color': '#F6EFE0',
          },
          '.list-item-v2-module__row:hover': {
            'background-color': '#FFFCEB',
          },
          '.list-item-v2-module__highlighted': {
            'background-color': '#E7D4AF',
          },
          '.list-item-v2-module__rowContainer': {
            'background-color': '#FFFDF9',
            'border-top': '1px solid #EFE2C8',
          },
          '.data-sources-v2-module__viewSwitcherTabs, .data-sources-v2-module__dataSourcesV2Container':
            {
              'background-color': '#FBF7F0',
            },
          '.data-sources-v2-module__viewSwitcherIcons': {
            color: '#605030',
          },
          '.tab-module__headerText[aria-selected="true"] .data-sources-v2-module__viewSwitcherIcons':
            {
              color: '#15020C',
            },
          '.tab-module__tabHorizontal .tab-module__headerItem:after': {
            'background-color': '#15020C',
          },
          '.data-sources-v2-module__infoIconContainer .icon-module__iconStyle':
            {
              fill: '#605030',
            },
          '.data-sources-v2-module__infoIconContainer .icon-module__stroke-blue':
            {
              fill: '#15020C',
              stroke: '#15020C',
            },
        },
      },
    },
  },
})
